// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".arrivals-pie-chart .apexcharts-datalabels{opacity:.9 !important}.arrivals-pie-chart .apexcharts-datalabels.legend-mouseover-inactive{opacity:.9 !important}", ""]);
// Exports
module.exports = exports;
